import { z } from 'zod'

import { requiredString } from '@/utils/zod'

export const schoolBreakStatus = z.union([
  z.literal('active'),
  z.literal('past'),
  z.literal('future')
])

export const schoolBreakSchema = z.object({
  id: requiredString(),
  name: requiredString(),
  status: schoolBreakStatus,
  start_date: z.coerce.date(),
  end_date: z.coerce.date()
})
